import { CommonHelperFunctions, IComponentSetDto } from "@kuika/kuika-cl-model";
import Axios, { AxiosResponse } from "axios";
import { KMainFunctions } from "../shared/utility/main-functions";

const backendUrl = CommonHelperFunctions.GetBackendUrl();

export class ComponentSetService {
  // deprecated

  // TODO cagan değişmeli.

  public static async Get(id?: string): Promise<AxiosResponse<IComponentSetDto>> {
    try {
      const res = await Axios.get<null, AxiosResponse>(`${backendUrl}/componentsets/GetById/${id}`);
      return res;
    } catch (error: any) {
      KMainFunctions.exceptionHandler(error);
      return error;
    }
  }
}
